import React from 'react';
import I18n from 'i18n-js';
import { TCITooltip } from '@/components/ui/Tooltip';

interface Props {
  accessibilityMode?: boolean;
  restartPath: string;
}

const VocabularyGameRestartButton = ({ accessibilityMode = false, restartPath }: Props) => {
  const link = (
    <a
      aria-label={I18n.t('restart_vocab_game')}
      className="btn btn--md btn--outline-purple"
      data-method="delete"
      href={restartPath}
      rel="nofollow"
    >
      {I18n.t('restart')}
    </a>
  );

  if (accessibilityMode) return link;

  return (
    <TCITooltip>
      <TCITooltip.Trigger asChild>
        {link}
      </TCITooltip.Trigger>
      <TCITooltip.Content>
        {I18n.t('restart_vocab_game_teacher_tooltip')}
      </TCITooltip.Content>
    </TCITooltip>
  );
};

export default VocabularyGameRestartButton;
